/** Categoria — o outro eixo do alerta. Nao e derivada da gravidade. */
enum AlertCategoryEnum {
  BODY_SIGNS = 'sinais_corpo',
  LOW_SCORE = 'score_baixo',
  ENGAGEMENT = 'engajamento',
}

export default AlertCategoryEnum;
